import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';

import { SignUpForm } from './SignUpForm.js';
import { LoginForm } from './LoginForm.js';

import { SignInOrLoginRowOnModal } from './SignInOrLoginRowOnModal.js';

import { SIGN_UP, LOGIN_LINK_TEXT } from '../../constants/Forms';

export const SignUpOrLoginModalContent = ({ path, user }) => {
  const [isOnSignUp, setIsOnSignUp] = useState(true);

  const handleButtonClick = (form) => {
    setIsOnSignUp(form === '/signup');
    mixpanel.track('LOGIN_SIGNUP_ROW', {
      path,
    });
  };

  if (user?.id) {
    return null;
  }

  return (
    <div style={{ marginTop: '20px' }}>
      <SignInOrLoginRowOnModal
        currentForm={isOnSignUp ? SIGN_UP : LOGIN_LINK_TEXT}
        userId={user.id}
        onButtonClick={handleButtonClick}
      />
      {isOnSignUp ? <SignUpForm path={path} /> : <LoginForm path={path} />}
    </div>
  );
};
